import React from 'react';

const FullSizeLoader = ({ fullScreen }) => {
  const classname = 'full-size-loader';

  return (
    <div className={`${classname} ${fullScreen ? `${classname}--full` : ''}`}>
      <div className="loader"></div>
    </div>
  );
};

export default FullSizeLoader;
